import { Pipe, PipeTransform } from '@angular/core';

const mapping: Record<string, string> = {
  speed_limit: 'Speed Limit',
  hard_brakes: 'Hard Brakes',
  fast_acceleration: 'Fast Acceleration',
};

@Pipe({
  name: 'safetyType',
})
export class SafetyTypePipe implements PipeTransform {
  public transform(value: string): string {
    return mapping[value];
  }
}
